/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _compact from 'lodash/compact'
import { analytics } from 'services/Analytics'
import { onCheckAuth, onStartLogoutWithRedirect } from 'redux-app/actionCreators/auth'
import { onGetSubscriptionsPlans } from 'redux-app/actionCreators/subscription'
import { onLoadTexts } from 'redux-app/modules/localization'
import { onGetContacts } from 'redux-app/modules/contacts'
import { getUserDetails } from 'api/client/actions/user'
import { getAppConfig, getRecaptchaWhiteListConfig } from 'api/client/actions/settings'
import { isUserAuthorizated } from 'redux-app/selectors/auth'

const initialLoadCreator = (
  getLoadActions = state => [],
  getDefaultRequestParams = state => ({}),
  getDefaultMetaParams = state => ({}),
) => () => (dispatch, getState) => {
  const state = getState()
  const loadActions = getLoadActions(state)
  const defaultRequestParams = getDefaultRequestParams(state)
  const defaultMetaParams = getDefaultMetaParams(state)
  return Promise.all(loadActions.map(actionCreator => {
    const params = [
      defaultRequestParams[actionCreator.toString()],
      defaultMetaParams[actionCreator.toString()],
    ]
    return dispatch(
      actionCreator(..._compact(params)),
    )
  }))
}

export const coreInitialLoad = () => (dispatch, getState) => {
  const state = getState()

  const actions = [
    () => dispatch(onCheckAuth())
      .catch(() => {
        dispatch(onStartLogoutWithRedirect())
      }),
    () => dispatch(getAppConfig({ noAuth: true, mock: true })),
    () => dispatch(getRecaptchaWhiteListConfig({ noAuth: true, mock: true })),
    // commented while no i18n
    // () => getLanguages({ noAuth: true, mock: true }),
    () => dispatch(onLoadTexts()),
    () => dispatch(onGetSubscriptionsPlans()),
    () => dispatch(onGetContacts()),
    () => analytics.init(getState),
  ]
  if (isUserAuthorizated(state)) {
    actions.push(() => dispatch(getUserDetails({ mock: true })))
  }

  return Promise.all(actions.map(action => action()))
}

export const profileInitialLoad = initialLoadCreator(
  () => [
    // getProfile,
  ],
)
